<template lang='pug'>
v-card
  v-container(fluid)
    v-layout(row wrap class='legend')
      v-flex(class='legend-col')
        span(class='legend-free mr-3')
        span(class='legend-text') Время свободно
      v-flex(class='legend-col')
        span(class='legend-busy mr-3')
        span(class='legend-text') Время занято
</template>

<script>
export default {}
</script>

<style scoped>
.legend-col {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}
.legend-free,
.legend-busy {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
}
.legend-free {
  background: #e8f5e9;
}
.legend-busy {
  background: #fce4ec;
}
.legend-text {
  font-size: 13px;
}
</style>
